import { CUSTOM_ERROR_NAME } from "./constants";
export class CustomErrorClass extends Error {
    constructor(severity, message, description) {
        super(message);
        this.severity = severity;
        this.description = description;
        this.name = CUSTOM_ERROR_NAME;
        Object.setPrototypeOf(this, CustomErrorClass.prototype);
    }
}
//# sourceMappingURL=custom-error.class.js.map